//import Dashboard from "../screens/auth/Dashboard";
import About from "../screens/users/About";
import Contact from "../screens/users/Contact";
import Home from "../screens/users/Home";
//import Booking from "../screens/auth/Booking";
//import Profile from "../screens/auth/Profile";
import CabDetails from "../components/UserSideComponents/CabPackage/CarDetailsPage";
import TourDetails from "../components/UserSideComponents/TourPackage/TourDetails";
import CabList from "../screens/users/CabList";
import TourList from "../screens/users/Tourlist";
// import Tourtypes from "../screens/auth/TourTypes";
// import Tours from "../screens/auth/Tours";
// import Cabs from "../screens/auth/Cabs";
//import Inquiry from "../screens/auth/Inquiry";
// import CabPackage from "../screens/auth/CabPackage";
// export const authRoutes = [
//   {
//     path: "/dashboard",
//     component: <Dashboard />,
//   },
//   {
//     path: "/bookings",
//     component: <Booking />,
//   },
//   {
//     path: "/profile",
//     component: <Profile />,
//   },
//   {
//     path: "/tour-types",
//     component: <Tourtypes />,
//   },
//   {
//     path: "/tours",
//     component: <Tours />,
//   },
//   {
//     path: "/cabs",
//     component: <Cabs />,
//   },
//     {
//     path: "/inquiry",
//     component: <Inquiry />,
//   },
//   {
//     path: "/cab-packages",
//     component: <CabPackage />,
//   },
// ];

// export const nonAuthRoutes = [
//   {
//     path: "/login",
//     component: <Login />,
//   },
//   {
//     path: "/register",
//     component: <Register />,
//   },
//   {
//     path: "/forgot-password",
//     component: <ForgotPassword />,
//   },
// ];

export const userRoutes = [
  {
    path: "/",
    component: <Home />,
  },
  {
    path: "/about",
    component: <About />,
  },
  {
    path: "/contact",
    component: <Contact />,
  },
  {
    path: "/tour",
    component: <TourList />,
  },
  {
    path: "/car",
    component: <CabList />,
  },
  {
    path: "/tour-details/:id",
    component: <TourDetails />
  },
    {
    path: "/cab-details/:id",
    component: <CabDetails />
  },
];
